/**
 * author：Qian.qianchen 2018-11-13
 * weibo模块左侧
 */
'use strict';
angular.module('editingCenterWeiBoLeftModule', []).controller('weiboLeftCtrl', [
    '$scope',
    '$q',
    '$state',
    '$location',
    'trsHttpService',
    '$timeout',
    '$element',
    'editingMediatype',
    'noticeWindowService',
    function($scope, $q, $state, $location, trsHttpService, $timeout, $element, editingMediatype, noticeWindowService) {
        initStatus();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]} [return description]
         *
         */
        function initStatus() {
            $scope.router = $location.path().split('/');
            $scope.status = {
                selectedItem: $scope.router[3] || '',
                isdownPicShow: false,
                selectedChnlId: '',
            };
            $scope.data = {
                channels: [],
                selected: {},
                AccountFirstFlag: {}, // 用于校验第一次进入
            };
        }

        /**
         * [setWeiBoSelectedItem description] 选择左侧栏
         * @param {[type]} item [description]
         */
        // $scope.setWeiBoSelectedItem = function(item) {
        //     getWeiBoAccessAuthority().then(function() {
        //         $scope.status.selectedItem = item;
        //         $state.go('front.editctr.weibo.' + $scope.status.selectedItem, { fctype: $scope.status.weiboAccessAuthority.FACHUDEPINGLUN, sdtype: $scope.status.weiboAccessAuthority.SHOUDAODEPINGLUN, atwopltype: $scope.status.weiboAccessAuthority.ATWODEPINGLUN, atwotype: $scope.status.weiboAccessAuthority.ATWODEWEIBO }, { reload: "front.editctr.weibo." + $scope.status.selectedItem });
        //     });
        // };

        /**
         * [initWeiBoChnl description] 初始化左侧栏
         * @return {[type]} [description]
         */
        function initWeiBoAccounts() {
            var deffer = $q.defer();
            if ($scope.data.channels && $scope.data.channels.length !== 0) {
                deffer.resolve();
                return deffer.promise;
            }
            // var params = {
            //     serviceid: 'wcm61_scmaccount',
            //     methodname: 'findAccountsToJson',
            //     SiteId: '',
            //     MediaType: 5,
            // };
            var params = {
                MediaType: editingMediatype.weibo,
                PAGESIZE: 1000,
                methodname: 'queryWebSitesByMediaType',
                serviceid: 'mlf_mediasite',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.channels = data.DATA;
                $scope.data.selected = data.DATA[0];
                $scope.status.selectedChnlId = $state.params.wbchannelid ? $state.params.wbchannelid : data.DATA[0].ACCOUNTID;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getWeiBoAccessAuthority description] 获取微博的权限
         * @return {[type]} [description] promise
         */
        function getWeiBoAccessAuthority() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryCanOperOfMicroblog',
                MicroBlogId: $scope.status.selectedChnlId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                deffer.resolve(data);
                $scope.status.weiboAccessAuthority = data;
            });
            return deffer.promise;
        }
        
        // 选择微博渠道的栏目
        $scope.switchChannel = function(platform, channel) {
            $scope.data.selected = channel;
            var routerName = 'front.editctr.weibo.' + platform;
            $state.go(routerName, { wbchannelid: channel.ACCOUNTID, channelid: channel.CHANNELID}, { reload: routerName });
            $scope.status.selectedChnlId = channel.ACCOUNTID;
            getWeiBoAccessAuthority();
            $scope.status.selectRecycle = false;
            // 第一次进来的标志 调用有效期验证的弹窗提醒
            if (!$scope.data.AccountFirstFlag[channel.ACCOUNTID]) {
                $scope.loadingPromise = noticeWindowService.getAccountValidityInfo(editingMediatype.weibo, channel);
                $scope.data.AccountFirstFlag[channel.ACCOUNTID] = true;
            }
        };

        /**
         * [autoLocation 自动定位]
         *
         * @param  {[type]}  platform
         *   [platform description]
         *
         * @return  {[type]}
         *   [return description]
         */
        $scope.autoLocation = function(platform) {
            initWeiBoAccounts().then(function() {
                $timeout(function() {
                    var routerArray = $state.current.name.split('.');
                    if (routerArray.length === 3 || routerArray.length === 4) {
                        if ($scope.status.selectedChnlId !== undefined) {
                            $scope.switchChannel(platform, $scope.data.selected);
                            // $state.go('front.editctr.weibo.' + platform, { wbchannelid: $scope.status.selectedChnlId });
                        } else {
                            $element.find('a')[0].click();
                        }
                    } else {
                        $scope.status.selectedChnlId = $state.params.wbchannelid;
                    }
                    getWeiBoAccessAuthority();
                });
            });
        };

        /**
         * [headPicload description] 头像未能正常显示时显示默认头像
         * @param  {[object]} item [description] 微博账号对象
         * @return {[type]}      [description]
         */
        $scope.headPicload = function(item) {
            var imgObj = new Image();
            imgObj.src = item.HEADPIC;
            $(imgObj).on('error', function() {
                item.picUrl = './images/user_icon.jpg';
            });
            $(imgObj).on('load', function() {
                item.picUrl = item.HEADPIC;
            });
        };

        // 打开废稿箱
        $scope.toRecycle = function(platform) {
            $scope.status.selectRecycle = platform;
            var routerName = 'front.editctr.weibo.' + platform;
            $state.go(routerName, { wbchannelid: $state.params.wbchannelid, channelid: $state.params.channelid }, { reload: routerName });
            $scope.status.selectedChnlId = '';
        };
    },
]);
